import { Spinner } from 'components/Elements/Spinner';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import * as React from 'react';

const variants = {
  primary: 'bg-[#26C4FF] text-white hover:bg-gray-50:text-primary-100',
  secondary: 'bg-secondary-100 text-white hover:bg-gray-50:text-secondary-100',
  inverse: 'bg-[#FCE7C2] text-gray-900  hover:bg-primary-100:text-white ',
  inverseSecondary: 'bg-[#D9F5FF] text-gray-900',
  danger: 'bg-red-600 text-white hover:bg-red-50:text-red-600',
  dark: 'bg-gray-800 text-white hover:bg-gray-50:text-gray-700',
  outline: 'border border-primary-100  text-primary-100 hover:bg-primary-100:text-white ',
};

const sizes = {
  xs: 'py-1 px-2 font-black text-xs',
  sm: 'py-2 px-2 font-black text-sm',
  md: 'py-3 px-6 font-black text-md',
  lg: 'py-3 px-8 font-black text-lg',
};

export const Button = React.forwardRef(
  (
    {
      type = 'button',
      className = '',
      variant = 'primary',
      size = 'md',
      isLoading = false,
      startIcon,
      endIcon,
      disabled,
      ...props
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        type={type}
        disabled={disabled}
        className={clsx(
          'flex justify-center items-center dark:border-none disabled:opacity-70 disabled:cursor-not-allowed rounded-full shadow-sm font-medium focus:outline-none',
          variants[variant],
          sizes[size],
          className
        )}
        {...props}
      >
        {isLoading && <Spinner size="sm" className="text-current" />}
        {!isLoading && startIcon}
        <span className="mx-2 whitespace-nowrap">{props.children}</span> {!isLoading && endIcon}
      </button>
    );
  }
);

Button.displayName = 'Button';

Button.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'inverse', 'danger', 'outline', 'dark', 'secondary']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  isLoading: PropTypes.bool,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
};
